/* ------------------------------------------------------------------ */
/* URL query param serialisation for shareable calculator links         */
/* ------------------------------------------------------------------ */

export function encodeCalculatorParams(
  params: Record<string, string | number | boolean>,
): string {
  const searchParams = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    searchParams.set(key, String(value))
  }
  return searchParams.toString()
}

export function decodeCalculatorParams<
  T extends Record<string, string | number | boolean>,
>(defaults: T, searchParams: URLSearchParams): T {
  const result = { ...defaults }
  for (const key of Object.keys(defaults)) {
    const raw = searchParams.get(key)
    if (raw === null) continue
    const defaultVal = defaults[key]
    if (typeof defaultVal === "number") {
      const num = parseFloat(raw)
      if (!isNaN(num)) (result as Record<string, unknown>)[key] = num
    } else if (typeof defaultVal === "boolean") {
      ;(result as Record<string, unknown>)[key] = raw === "true"
    } else {
      ;(result as Record<string, unknown>)[key] = raw
    }
  }
  return result
}
